<template>
  <!--<hello-world />-->
  <div id="componentInboxChat" class="" @keyup.esc="onEscPress" tabindex="0">
    <ChatMessage :heightDefault="this.heightDefault" :messages="this.messages" :thereIsImg="this.thereIsImgCliptoBoard" @clearImgCopiedFromObj="clearImg"/>
    <BoxCmd :namePadre="'InboxChat'" :userName="this.userName" :userNameColor="this.userNameColor" :messages="this.messages" @clearImgCopiedFromObj="clearImg" @new="addNewMessage" @pasteImg="getCliptoBoardImg" @dropImgFile="processImgFile" :thereIsImg="this.thereIsImgCliptoBoard" :imgCopied="this.imgCopied"/>
    
  </div>
</template>

<script>

import BoxCmd from "../components/BoxCmd.vue";
import ChatMessage from "../components/ChatMessage.vue";
import Pusher from 'pusher-js';
import { v4 as uuidv4 } from 'uuid';

export default {
  name:"InboxChat",
  props:["userName","userNameColor"],
  created(){
    //console.log("antes de crearse");
    
  },
  mounted(){
    /*if(this.userName != "user"){
      this.$router.push({ name: 'Cmd' });
      console.log("gg");
      return;
    }*/
      //console.log("userName Cmd.vue: "+this.userName);
    if(localStorage.getItem('msgsChat')){
      //await this.sleepTime(2);
      this.messages = JSON.parse(localStorage.getItem('msgsChat'));
      /*setTimeout(()=>{
        document.getElementsByClassName("box-h")[0].style.height = "calc(70vh - 80px)";
      },1);*/
      setTimeout(()=>{
        this.goToEndSroll();
      },1);
    }

    Pusher.logToConsole = true;
    var pusher = new Pusher('ef1440082a220248d3b5', {
      cluster: 'us2'
    });
    var channel = pusher.subscribe('my-channel2');
    //Cambie a funcion flecha para poder acceder al this
    //Tambien se puede agregar el .bind y pasarle como parametro el this
    //Si no se hace ninguno de los dos entonces no podrá acceder a las variables
    channel.bind('my-event2', (data) => {
      if(data.sender != this.userName){
        //console.log("Hola ",JSON.stringify(data));
        let msg = {
            id:uuidv4(),//Date.now(),//Math.floor(Math.random() * 10000),
            sender:data.sender,
            colorSender:data.colorSender,
            text:data.text,
            isFromHim:data.isFromHim,
            imgBase64:(data.imgBase64!=null)?"data:image/png;base64,"+data.imgBase64:null,
            imgUrl:data.imgUrl
        };
        setTimeout(()=>{
          //document.getElementsByClassName("box-h")[0].style.height = "calc(70vh - 80px)";
          document.getElementsByClassName("box-h")[0].style.height = "calc(100vh - 170px)";
        },1);
        this.addNewMessage(msg);
      }
    });

  },
  data:()=>({
    thereIsImgCliptoBoard:false,
    imgCopied:null,
    messages:[
    ],
    heightDefault:"calc(100vh - 170px)",
    overlayInsertUser:false
  }),
  methods:{
    clearImg(){
      this.thereIsImgCliptoBoard = false;
      this.imgCopied = null;
    },
    async addNewMessage(msg){
      await this.AsyncPushArray(msg);
      this.goToEndSroll();
    },
    async goToEndSroll(){
      document.querySelector(".box-h").scrollTop = document.querySelector(".box-h").scrollHeight;
    },
    async AsyncPushArray(msg){
      return new Promise((resolve,reject)=>{
        this.messages.push(msg)
        localStorage.setItem('msgsChat',  JSON.stringify(this.messages));
        resolve();
      });
    },
    getCliptoBoardImg(e){
      document.addEventListener("paste",e=>{
        if(e.clipboardData.files.length > 0){
          console.log(e.clipboardData.files);
          if(e.clipboardData.files[0].type.startsWith("image/")){
            this.setPreviewImg(e.clipboardData.files[0]);
          }
        }
      });
    },
    processImgFile(e){
      let files = e.dataTransfer.files;
      let file = files[0];
      this.setPreviewImg(file);
    },
    async setPreviewImg(file){
      this.imgCopied = await this.AsyncLoadImg(file);
      /*console.log(this.imgCopied);
      return;*/
      //console.log("Hola");
      document.querySelector("#imgPreview").src = this.imgCopied;
      setTimeout(()=>{
        //document.getElementsByClassName("box-h-without-img")[0].style.height = "calc(70vh - 80px)";
        document.getElementsByClassName("box-h")[0].style.height = "calc(100vh - 170px)";
        document.getElementById('imgPreviewBox').focus();
      },1);
      
    },
    async AsyncLoadImg(file){
      return new Promise((resolve,reject)=>{
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          this.thereIsImgCliptoBoard = true
          //console.log("Img");
          resolve(fileReader.result)
          };
      });
    },
    async sleepTime(s){
      return new Promise((resolve,reject)=>{
        setTimeout(resolve(),s*1000);
      });
    },
    onEscPress(){
        this.clearImg();
        setTimeout(() => {
            //Si no le pongo el setTime se demora en ejecutar el cambio de la variable thereIsImg después de llamar al evento con emit
            //console.log("Hay Imagen? " +this.thereIsImg);
            document.querySelector(".box-h").scrollTop = document.querySelector(".box-h").scrollHeight;
        }, 1);
    },
  },
  /*watch:{
    messages:(newMsgs)=>{
      localStorage.msgs = newMsgs;
    }
  },*/
  components:{
    BoxCmd,
    ChatMessage,
  }
}
</script>
